module.exports = __webpack_public_path__ + "img/anim-jeune.9aa02b3a.jpg";